import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SessionService } from '../session/session.service';
import { TransactionListElement } from '../../domain/transaction-list-element';
import { SystemConfig } from '../../config/system-config';
import { TranslationService } from '../translation/translation.service';

@Injectable()
export class TransactionListService {

  constructor(private http:Http,
              public sessionService:SessionService,
              public translationService: TranslationService) {
  }

  loadTransactionList():void {
    this.http.get(SystemConfig.Endpoint.TRANSACTION_LIST,{
      headers: new Headers()
    }).subscribe((response:Response) => this.handleTransactionListResponse(response.json()),
      (error:Error) => this.handleTransactionListError());
  }

  handleTransactionListResponse(response:any) {
    this.sessionService.transactionList = (response && response.FinancialOperations) ? response.FinancialOperations : [];
  }

  handleTransactionListError():void {
    this.sessionService.transactionList = [];
    this.sessionService.showInfoBubbleDialog(this.translationService.translate('default.error'), true);
  }

  stornoTransaction(element:TransactionListElement):void {
    this.http.post(SystemConfig.Endpoint.STORNO_TRANSACTION, {"Code": element.CodeInfo}, {
      headers: new Headers()
    }).subscribe((response:Response) => this.handleStornoResponse(),
      (error:Error) => this.handleStornoError());
  }

  handleStornoResponse() {
    this.loadTransactionList();
  }

  handleStornoError():void {
    this.sessionService.showInfoBubbleDialog(this.translationService.translate('default.error'), true);
  }

  /*disburse(element:TransactionListElement) {
   return this.http.post(SystemConfig.Endpoint.TRANSACTION_DISBURSE, {Code: element.Code, Number: element.Number}, {
   headers: new Headers()
   });
   }*/
}




// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/transaction-list/transaction-list.service.ts